import script from "./CollectionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionsTable.vue?vue&type=script&setup=true&lang=js"

import "./CollectionsTable.vue?vue&type=style&index=0&id=142b6c53&lang=scss"

const __exports__ = script;

export default __exports__